import { Form, Input, Button, Select } from 'antd'
import axios from 'axios'
import { useState } from 'react'
import { ADMIN, PERMISSIONKEYS, PERMISSIONLABELS, PERMISSIONS, ROLEKEYS } from '../../../utils/Permissions.const'

export const PermissionForm = ({ onSubmit, initialValues = {}, isLoading }) => {
  const [form] = Form.useForm()
  const [role, setRole] = useState(initialValues['role'])

  const validateEmail = async (_, value) => {
    if (!value) return Promise.reject('נא להוסיף אימייל')

    try {
      const { data } = await axios.get(`/api/user/validate?email=${value}`)

      if (data?.email) {
        form.setFieldsValue({ userId: data._id })
        return Promise.resolve()
      } else {
        return Promise.reject('אימייל לא תקין')
      }
    } catch (error) {
      return Promise.reject('אימייל לא תקין')
    }
  }
  return (
    <Form layout="vertical" form={form} onFinish={onSubmit} initialValues={initialValues}>
      <Form.Item hidden name="_id">
        <Input />
      </Form.Item>
      <Form.Item name="userId" noStyle>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item
        name="email"
        label={'מייל'}
        validateTrigger="onBlur"
        rules={[{ required: true, validator: validateEmail }]}
      >
        <Input />
      </Form.Item>
      <Form.Item rules={[{ required: true }]} name="role" label={'סטטוס'}>
        <Select
          onChange={(value) => setRole(value)}
          options={[
            { value: ROLEKEYS.ADMIN, label: ADMIN },
            { value: ROLEKEYS.PERMISSIONS, label: PERMISSIONS },
          ]}
        />
      </Form.Item>
      <Form.Item name="permissions" label={'פיצ׳רים'}>
        <Select
          mode="multiple"
          disabled={role === ROLEKEYS.ADMIN}
          options={[
            { value: PERMISSIONKEYS.GAMES, label: PERMISSIONLABELS.MANAGE_GAMES },
            { value: PERMISSIONKEYS.CHAMPIONS, label: PERMISSIONLABELS.CHAMPIONS_LEAGUE },
            { value: PERMISSIONKEYS.CATEGORIES, label: PERMISSIONLABELS.SPORTS_CATEGORIES },
            { value: PERMISSIONKEYS.LOGS, label: PERMISSIONLABELS.LOGS },
            { value: PERMISSIONKEYS.RECORDS, label: PERMISSIONLABELS.RECORDS },
            { value: PERMISSIONKEYS.TEAMS, label: PERMISSIONLABELS.MANAGE_TEAMS },
            { value: PERMISSIONKEYS.USERS, label: PERMISSIONLABELS.MANAGE_USERS },
          ]}
        />
      </Form.Item>

      <Button block loading={isLoading} style={{ marginTop: 24 }} type="primary" htmlType="submit">
        {'שמירה'}
      </Button>
    </Form>
  )
}
